import { __decorate } from "tslib";
import { AutoEncoder, EnumDecoder, field, StringDecoder } from '@simonbackx/simple-encoding';
import { SecurityCodeSendMethod } from '../members/SecurityCodeSendMethod.js';
export class SendMemberSecurityCodeResponse extends AutoEncoder {
    method;
    /**
     * A masked description of where the code was sent to, safe to show to the user.
     * E.g. a masked phone number for SMS. Empty for email (sent to all known addresses).
     */
    maskedRecipient = '';
}
__decorate([
    field({ decoder: new EnumDecoder(SecurityCodeSendMethod) })
], SendMemberSecurityCodeResponse.prototype, "method", void 0);
__decorate([
    field({ decoder: StringDecoder })
], SendMemberSecurityCodeResponse.prototype, "maskedRecipient", void 0);
//# sourceMappingURL=SendMemberSecurityCodeResponse.js.map